import React, { useEffect, useState } from 'react';

import makeStyles from '@material-ui/core/styles/makeStyles';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import ShoppingBasketOutlinedIcon from '@material-ui/icons/ShoppingBasketOutlined';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import { AccountMenu } from './AccountMenu';

const useStyles = makeStyles((theme) => ({

    navLinkActive: {
        color: '#FF8C23',
        textDecoration: 'none'
    },
    organisation: {
        backgroundColor: '#FFF',
        position: 'absolute',
        right: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
        [theme.breakpoints.up('md')]: {
            right: theme.spacing(10),
            display: 'flex'
        },
    },
    organisationText: {
        display: 'none',
        marginRight: theme.spacing(1),
        textAlign: 'right',
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            display: 'unset'
        },
    },
    avatar: {
        fontSize: '1.1rem',
        border: '2px solid #E0E0E0',
    },
    avatarFaded: {
        fontSize: '1.1rem',
        border: '2px solid #E0E0E0',
        opacity: '0.8',
    },
    avatarGroup: {
        cursor: 'pointer',
    },
    navIcons: {
        display: 'none',
        alignSelf: 'center',
        marginRight: theme.spacing(18),
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        }
    },
    navIcon: {
        fontSize: '1.65rem',
        paddingLeft: theme.spacing(2),
    }

}));


const AccountWidget = ({ handleSwitchOrganisation, useProfileState, handleLogout, config }) => {

    const classes = useStyles();
    const [anchor, setAnchor] = useState(null);
    const [thisLoading, setThisLoading] = useState(true);
    const { user, organisation, error, update, loggedIn, loading } = useProfileState();

    useEffect(() => {
        if (!loading) {
            setThisLoading(false);
        }
    }, [loading, update])

    const getLoginUrl = () => {
        let url = window.location.href;
        let link = `${config.accountUrl}?ReturnUrl=${url}`;
        if (url.includes("logout") || url.includes("register") || url.includes("reset") || url.includes("invite")) {
            link = config.accountUrl;
        }
        return link;
    };

    const getRegisterUrl = () => {
        let link = `${config.accountUrl}/register`
        return link;
    };

    const handleOpenMenu = (event) => {
        event.preventDefault();
        setAnchor(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchor(null);
    };

    const notLoggedInContent = () => {
        return (
            <React.Fragment>
                <div className={classes.organisation}>
                    {/* <Icons /> */}
                    <div className={classes.organisationText}>
                        <Typography variant="subtitle1" style={{ lineHeight: '1.2' }}>
                            Please&nbsp;
                            <Link
                                underline="none"
                                className={classes.navLinkActive}
                                href={getLoginUrl()}
                            >
                                login
                            </Link>
                        </Typography>
                        <Typography variant="subtitle2" style={{ lineHeight: '1.2' }}>
                            or&nbsp;
                            <Link
                                underline="none"
                                className={classes.navLinkActive}
                                href={getRegisterUrl()}
                            >
                                register
                            </Link>
                        </Typography>
                    </div>
                    <AvatarGroup spacing="small">
                        <Avatar className={classes.avatar}></Avatar>
                        <Avatar className={classes.avatarFaded}><AccountBalanceOutlinedIcon /></Avatar>
                    </AvatarGroup>
                </div>
            </React.Fragment>
        );
    }

    const Icons = () => {
        return (
            <div className={classes.navIcons}>
                <ShoppingBasketOutlinedIcon className={classes.navIcon} />
                <NotificationsNoneOutlinedIcon className={classes.navIcon} />
            </div>
        );
    }


    return (
        thisLoading ?
            <div></div>
            :
            loggedIn ?
                error ?
                    <div className={classes.organisation}>
                        Error getting user data
                    </div>
                    :
                    <React.Fragment>
                        <div className={classes.organisation}>
                            {/* <Icons /> */}
                            <div className={classes.organisationText}>
                                <Typography variant="subtitle1" style={{ lineHeight: '1.2' }}>
                                    {user.forename} {user.surname}
                                </Typography>
                                <Typography variant="subtitle2" style={{ lineHeight: '1.2' }}>
                                    {organisation.organisationName}
                                </Typography>
                            </div>
                            <AvatarGroup className={classes.avatarGroup} spacing="small" onClick={Boolean(anchor) ? handleCloseMenu : handleOpenMenu}>
                                <Avatar className={classes.avatar} src={`${config.cdnUrl}/images/avatars/${user.id}?rid=${Date.now()}`}></Avatar>
                                <Avatar className={classes.avatarFaded} src={`${config.cdnUrl}/images/avatars/${organisation.id}?rid=${Date.now()}`}><AccountBalanceOutlinedIcon /></Avatar>
                            </AvatarGroup>
                        </div>
                        <AccountMenu
                            anchor={anchor}
                            config={config}
                            useProfileState={useProfileState}
                            handleCloseMenu={handleCloseMenu}
                            handleSwitchOrganisation={handleSwitchOrganisation}
                            handleLogout={handleLogout}
                        />
                    </React.Fragment>
                :
                notLoggedInContent()
    );
}

export default AccountWidget;